import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-settings-body',
  templateUrl: './settings-body.component.html',
  styleUrls: ['./settings-body.component.scss']
})
export class SettingsBodyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
